// WhatsApp Click-to-Chat helper – number passed as argument so it works
// with dynamic content from admin panel.

export const buildWhatsAppUrl = (phone, message = "") => {
  const text = encodeURIComponent(message || "Merhaba, Aktav Yarka hakkında bilgi almak istiyorum.");
  return `https://api.whatsapp.com/send?phone=${phone}&text=${text}`;
};

export const openWhatsApp = (phone, message = "") => {
  const text = encodeURIComponent(message || "Merhaba, Aktav Yarka hakkında bilgi almak istiyorum.");
  const isMobile = /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
  const url = isMobile
    ? `https://api.whatsapp.com/send?phone=${phone}&text=${text}`
    : `https://web.whatsapp.com/send?phone=${phone}&text=${text}`;
  const win = window.open(url, "_blank", "noopener,noreferrer");
  if (!win) window.location.href = url;
};
